export const SET_DRUG_PRODUCT_INFO = 'SET_DRUG_PRODUCT_INFO';
export const SET_DRUG_PRODUCT_INFO_FROM_SEARCH = 'SET_DRUG_PRODUCT_INFO_FROM_SEARCH';
